import React from 'react';
import CommissionsList from './ISList';

const CommissionContent = () => {
  return <CommissionsList />;
};

export default React.memo(CommissionContent);
